export function getEnv(key: string, fallback?: string): string | undefined {
  if (import.meta.env) {
    const value = (import.meta.env as Record<string, string | undefined>)[key]
    if (value !== undefined) {
      return value
    }
  }

  return fallback
}

export function getEnvBoolean(key: string, fallback = false): boolean {
  const value = getEnv(key)
  if (value === undefined) {
    return fallback
  }
  return value === 'true' || value === '1'
}
